import type { FC } from "react";

import { Alert, Flex, Skeleton, Text } from "src/components";
import { Color, FontWeight } from "src/theme";
import { useTranslation } from "src/translations";
import { OutageType } from "src/types";

const TYPE_TITLE: Record<OutageType, string> = {
    [OutageType.PlannedOutage]: "outage.planned",
    [OutageType.UnplannedOutage]: "outage.unplanned",
    [OutageType.UnplannedPartialOutage]: "outage.unplannedPartial",
} as const;

type OutageTypeProps = {
    type?: OutageType;
    isLoading?: boolean;
};

export const Type: FC<OutageTypeProps> = ({ type, isLoading }) => {
    const { t } = useTranslation();

    return (
        <Flex flexDirection="column" gap="0.5rem">
            <Text weight={FontWeight._700}>{t("outageDetail.type")}</Text>
            {isLoading ? (
                <Skeleton width="10rem" />
            ) : (
                <Flex alignItems="center" gap="0.5em">
                    <Alert type={type} clickable={false} />
                    <Text color={Color.textPrimary}>{t(TYPE_TITLE[type!])}</Text>
                </Flex>
            )}
        </Flex>
    );
};
